import mitt from 'mitt';

type Events = {
  Announcement: { active: boolean };
};

const emitter = mitt<Events>();

export default emitter;